export default __webpack_public_path__ + "static/media/house_seven.6a65b3d6.jpg";